import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Grid, Image, Table} from "antd";
import {connect, useDispatch} from "react-redux";
import {Subtitle1} from "../../../components";
import {createBillingEntity, deleteBillingEntity, editBillingEntity, fetchBillingEntities, resetBillingEntityPagination, updateBillingEntitiesFilters} from "../../../app/Reducers";
import TableFilters from "../../../components/InputComponents/TableFilters";
import {
    appLog,
    containedButton,
    createFormInputsFromTableColumns,
    dialogCloser,
    emptyFun,
    emptyTable,
    executeChunkFn,
    getSkels,
    kebabMenus,
    onTableChange,
    responsiveTbl
} from "../../../common/helpers";

import KebabMenu from "../../../components/KebabMenu";
import * as Sentry from "@sentry/react";
import {errMsg, toastUp} from "../../../app/Reducers/reducerUtils";
import DynamicModalForm from "../../../components/DynamicModalForm";
import GetCookie from '../../../hooks/GetCookie';
import {PlusOutlined} from '@ant-design/icons';
import axios from 'axios';
import {mapboxToken} from '../../../configure/constants';
import {useAddressSearch} from '../../../hooks/useAddressSearch';
import {tr} from 'date-fns/locale';
const { useBreakpoint } = Grid;
const BillingEntities = ({ appConf,  billingEntityPagination, billingEntities, procedures }) => {
  const dispatch = useDispatch();
  const windowState = useBreakpoint();
  const token = GetCookie('accessToken')
  const uploadUrl = process.env.REACT_APP_ENDPOINT + '/files'
  const dateFormat = "YYYY-MM-DD";
  const [showAuditDialog, setShowAuditDialog] = useState(false);
  const [auditItem, setAuditItem] = useState(false);
  const [procedureOptions, setProcedureOptions] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [selected, setSelected] = useState(null)
  const [isExecuting, setisExecuting] = useState(false)
  const [isDynamicFormOpen, setDynamicFormOpen] = useState(false);
  const [formName, setFormName] = useState(undefined);
  const [defaultDynamicModalFormValues, setDefaultDynamicModalFormValues] = useState(undefined);
  const [dynamicFormComputedValues, setDynamicFormComputedValues] = useState(undefined);
  const [phoneValue, setPhoneValue] = useState(undefined);
  const [fileList, setFileList] = useState([]);
  const [addressOptions, setAddressOptions] = useState([])
  const debouncedAddressSearch = useAddressSearch(setAddressOptions, [])
  useEffect(() => {
    dispatch(fetchBillingEntities());
    return emptyFun
  }, []);
    useEffect(() => {
        // loadMap().catch(appLog)
      return emptyFun
  }, []);
    const loadMap = async () => {
        const response = await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/345.json`,
            { params: { access_token: mapboxToken,country:"us,ke"} });
        console.log({response})
    }
  useEffect(() => {
    setProcedureOptions([...procedures.map(item => ({ ...item, label: item.name, value: item.id }))])
    return emptyFun
  }, [procedures]);
  // console.log({ procedures })
  const onDocUploadChange = async ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (!newFileList[0]) {
      await setDynamicFormComputedValues({ ...dynamicFormComputedValues, image_id: undefined })
      return
    }
    newFileList = newFileList.map(async file => {
      if (file.response) {
        file.url = file.response.url;
        await setDynamicFormComputedValues({ ...dynamicFormComputedValues, image_id: file.response.data.id })
      }
      return file;
    });
  };

  const columns = [
    {
      title: 'Name', dataIndex: 'name', key: 'name', fltr: { filterable: true, type: 'text', editableCol: true, required: true, fullRow: true },
    },
    {
      title: 'Short Code', dataIndex: 'shortcode', key: 'shortcode', fltr: { filterable: true, type: 'text', editableCol: true, required: true, fullRow: true }
    },
    {
      title: 'Phone number', dataIndex: 'phone_number', key: 'phone_number', fltr: { filterable: false, type: 'phone', editableCol: true, required: false, fullRow: false }
    },
    {
      title: 'Logo', dataIndex: 'image', key: 'image_id', fltr: {
        filterable: false, type: 'upload', editableCol: true, required: false, fullRow: true, inputGroup: 'uploads',
        props: { listType: "picture", accept: "image/*", action: uploadUrl, headers: { 'Authorization': `Bearer ${token}` }, onChange: onDocUploadChange, maxCount: 1, fileList }
      },
      render: (image) => {
        return (<Image
          width={80}
          height={80}
          src={image?.url}
          fallback="data:image/png;base64,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"
        />);
      }
    },
    {
      title: 'Address', dataIndex: 'address', key: 'address',
      fltr: {
        filterable: true, type: 'select', options: addressOptions, editableCol: true, required: true, fullRow: true,
        props: {
          onSearch: (value) => debouncedAddressSearch(value),
          onSelect: (value,option) => setDynamicFormComputedValues({...dynamicFormComputedValues,address_2:value}),
          showSearch: true, filterOption: false, fullRow: true,
          currentAddress: defaultDynamicModalFormValues?.address
        }
      },
      ellipsis: true, invisible: true
    },
    {
      title: 'Address 2', dataIndex: 'address_2', key: 'address_2',
      fltr: {
        filterable: true, type: 'text', editableCol: true, required: true, fullRow: true
      },
      ellipsis: true, invisible: true
    },
    {
      title: 'Website', dataIndex: 'website', key: 'website', fltr: { filterable: false, type: 'text', editableCol: true, required: false, fullRow: true },
      render: (websiteUrl) => !!websiteUrl ? <div className={''}>
        <a rel={'noreferrer'} className={'text-blue-400'} href={websiteUrl} target={'_blank'}>
          View Website <i
          className="fas fa-external-link-alt"></i></a></div> : 'N/A'
    },
    {
      title: 'Procedure allocated', dataIndex: 'procedures', key: 'procedures', fltr: {
        filterable: false,
        type: 'select',
        props: { mode: "multiple" },
        options: procedureOptions,
        editableCol: true,
        required: true,
        fullRow: true
      },
      render: (procedures) => Array.isArray(procedures) ? procedures.map(item => item.name).join(', ') : ''
    },
    {
      title: 'Fax', dataIndex: 'fax', key: 'fax', fltr: {
        filterable: false,
        type: 'text',
        editableCol: true,
        required: false,
        fullRow: true
      },
      render: (fax) => fax || '-'
    },
    {
      title: 'Default Billing group', dataIndex: 'is_default', key: 'is_default',
      fltr: { filterable: false, type: 'checkbox', editableCol: true, required: false, fullRow: true },
      render: (text, record) => (
        <div className="status-container">
          <div className="dot-circle-active" style={{ background: record.is_default ? '#50D2A0' : "#fc223e" }}/>
          <Subtitle1>{record.is_default ? 'Yes' : 'No'}</Subtitle1>
        </div>
      )
    },
    {
      title: 'Action',
      fixed: "right",
      width:64,
      render: (record) =>
        (<KebabMenu
            menus={actionMenus}
            recordItem={record}
            handleMenuClick={kebabMenuClick}
            resource="billing entity"
            handleOk={() => handleOk(record)}
            showConfirmDialog={selected === record.id}
            handleCancel={handleCancel}
            confirmLoading={confirmLoading}
          />
        )
    }
  ]
  let billingEntityFormInputs = createFormInputsFromTableColumns(false, columns, phoneValue, setPhoneValue, null, null, dateFormat)
  //Do not pass inputs as a useState variable, it causes props of useState values not to propagate state to form items
  let dynamicFormInputFields = {
    'Edit billing entity': billingEntityFormInputs, 'Add billing entity': billingEntityFormInputs
  }

  const actionMenus = kebabMenus(true, false, false)
  const showPopconfirm = (id) => setSelected(id);

  async function kebabMenuClick(e, record) {
    switch (actionMenus[e.key].title) {
      case 'Edit':
        await openBillingEntityForm(record)
        break
      case 'Delete':
        showPopconfirm(record.id)
        break
      case 'Audit':
        break
      default:
    }
  }

  const handleOk = async (record) => {
    await setConfirmLoading(true)
    await dispatch(deleteBillingEntity(record.id))
    await setConfirmLoading(false)
    await setSelected(0)
  }

  const handleCancel = () => setSelected(0);

  async function handleFilterAction(action, values) {
    await dispatch(resetBillingEntityPagination())
    if (action === 'filter') {
      let pl = { filterData: { ...values }, pagination: billingEntityPagination }
      await dispatch(updateBillingEntitiesFilters([false, pl, true]))
      await dispatch(fetchBillingEntities(pl))
      await dispatch(updateBillingEntitiesFilters([true, pl, false]))
    }
    if (action === 'reset') {
      await dispatch(updateBillingEntitiesFilters([appConf.billingEntitiesFilters[0], undefined, true]))
      await dispatch(fetchBillingEntities())
      await dispatch(updateBillingEntitiesFilters([false, undefined, false]))
    }
    setIsVisible(false)
  }


  const openBillingEntityForm = async (record) => {
    // console.log({record})
    if (record) {
      const { image = undefined, procedures = undefined, ...rest } = record
      await setFileList(image ? [image] : [])
      await setDefaultDynamicModalFormValues(!!record ? { ...rest, procedures: !!procedures ? procedures.map(item => item.id) : [] } : undefined);
    }else {
      await setFileList( [])
      await setDefaultDynamicModalFormValues(undefined);
    }
    await setFormName(!!record ? 'Edit billing entity' : 'Add billing entity');
    await setDynamicFormOpen(true);
  };

  /**
   * This function is handling returned form entries from the dynamic form
   * */
  const onDynamicFormEntriesResult = async (entries) => {
    // console.log('entries.values: ',entries.values)
    try {
      switch (formName) {
        case 'Add billing entity':
          await executeChunkFn(dispatch, createBillingEntity, entries.values, setisExecuting, dialogCloser(setDynamicFormOpen), null)
          break;
        case 'Edit billing entity':
          await executeChunkFn(dispatch, editBillingEntity, entries.values, setisExecuting, dialogCloser(setDynamicFormOpen), null)
          break;
        default:
          return
      }
    } catch (e) {
      Sentry.captureException(e);
      console.log(e);
      toastUp(errMsg(e, false, formName), false);
    }
  };
  console.log({windowState})
  return (
    <div className="w-full overflow-y-auto overscroll-contain">
      {(isDynamicFormOpen && !!formName) && (
        <DynamicModalForm
          setDynamicFormOpen={setDynamicFormOpen}
          isDynamicFormOpen={isDynamicFormOpen}
          inputFields={dynamicFormInputFields[formName]}
          onDynamicFormEntriesResult={onDynamicFormEntriesResult}
          closeModal={dialogCloser(setDynamicFormOpen)}
          isExecuting={isExecuting}
          defaultValues={defaultDynamicModalFormValues}
          formName={formName}
          phoneValue={phoneValue} setPhoneValue={setPhoneValue}
          useUpdateTerminology={['Save', 'Saving']}
          computedValues={dynamicFormComputedValues}
        />
      )}
      <Table
        title={() => (<TableFilters datasource={columns}
                                    setIsVisible={setIsVisible}
                                    isVisible={isVisible}
                                    handleFilterAction={handleFilterAction}
                                    filters={appConf.billingEntitiesFilters[1]}
                                    showClear={appConf.billingEntitiesFilters[0]}
                                    loading={appConf.billingEntitiesFilters[2]}
                                    actionButton={containedButton(() => openBillingEntityForm(), 'Add Billing Entity', false, null, null, { icon: <PlusOutlined /> })}
        />)}
        loading={appConf.billingEntitiesFilters[2]} size={'small'}
        locale={{ emptyText: emptyTable('patient wounds.') }}
        scroll={{ x: 1500 }}
        virtual
        onChange={(pagination, filters, sorter) => onTableChange(pagination, filters, sorter, dispatch, fetchBillingEntities, appConf.billingEntitiesFilters, updateBillingEntitiesFilters, null)}
        onRow={(record) => ({
          onClick: async (event) => {
            await setAuditItem(record)
            await setShowAuditDialog(true)
          }
        })}
        {...getSkels((appConf.billingEntitiesFilters[2]), columns.filter(item=>!item.invisible), billingEntities)} pagination={billingEntityPagination}
      />
    </div>

  );
};


const mapStateToProps = (state) => ({

  activeUser: state.auth?.activeUser,
  billingEntities: state.masters.billingEntities,
  billingEntityPagination: state.masters.billingEntityPagination,
  procedures: state.appointments.procedures,
  appConf: state.appConf
});
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(BillingEntities);
